/* eslint-disable no-confusing-arrow */
/* eslint-disable no-useless-escape */
/* eslint-disable quotes */
/* eslint-disable prefer-template */
/* eslint-disable function-paren-newline */
/* eslint-disable max-len */
/* eslint-disable arrow-parens */
/* eslint-disable arrow-body-style */
import { FaCalendarAlt } from "react-icons/fa";
import moment from 'moment'
import { useContext, useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { Button, Col, Container, Row } from 'reactstrap'
import WithErrorBoundary from '_components/WithErrorBoundary'
import { BUYER_ORDER_UNPAID, BUYER_REFUNDED, HOST_ORDER_REFUNDED, HOST_ORDER_CANCELED, BUYER_ORDER_CANCELED, HOST_ORDER_UNPAID, HOST_ORDER_SUBMITTED_UNPAID, BUYER_ORDER_PAID } from '_utils/constant'
import orderApi from '_api/order'
import { getListEventAndDelivery, updateOpeningEventsOrders, getPackingListEvents } from '_redux/modules/event'
import userApi from '_api/user'
import {
  handleDataOrder,
  handleDataOrderByPercentage,
  handleDownloadPdf
} from '_utils/function'
import { formatNumberEng } from '_utils/formatNumber'
import { SelectIdGroupContext } from '_context/SelectGroupContext'
import { ConsolidatedContext } from '_context/ConsolidatedContext'
import { EVENT_STATUS_OPEN, EVENT_STATUS_CLOSE } from './components/SelectFilter/SelectEventStatus'
import OrderSearch from '../../pages/Event/ManageOrder/SearchOrder'
import OrderList from './components/OrderList'
import SelectFilter from './components/SelectFilter/index'
import NotFoundOrder from './components/NotFoundOrder'
import PaginationNumbers from './components/PaginationNumbers'
import { handleExportMultipleEventAndOrder } from './helpers/exportHelpers'
import SelectDateSyncData from './components/SelectDateSyncData'
import OrderListSkeleton from './components/Skeleton/Skeleton'
import './style.scss'
// import useShowNotification from "../../hooks/useShowNotification";

const format1 = 1
const format2 = 2
const now = Date.now() / 1000;

const checkMatchesPaymentStatus = (order, paymentStatus) => {
  return paymentStatus.some((statusOption) => {
    const { value, isPending, includeSubmitted } = statusOption
    if (isPending) {
      return (
        order.buyerStatus === BUYER_ORDER_PAID &&
        (order.status === HOST_ORDER_UNPAID || order.status === HOST_ORDER_SUBMITTED_UNPAID)
      )
    }

    if (value === BUYER_REFUNDED) {
      const isRefunded = order.status === HOST_ORDER_REFUNDED || order.buyerStatus === BUYER_REFUNDED
      return isRefunded
    }

    if (value === BUYER_ORDER_UNPAID) {
      return (
        order.buyerStatus === BUYER_ORDER_UNPAID &&
        (order.status === HOST_ORDER_UNPAID || order.status === HOST_ORDER_SUBMITTED_UNPAID)
      )
    }

    if (includeSubmitted) {
      return order.status === value || order.status === includeSubmitted
    }

    return order.status === value
  })
}

function ManageOrder() {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const context = useContext(SelectIdGroupContext)
  const { groupId } = context.infoGroupSelected
  const { listRef, count, addConsolidated, refreshConsolidated } = useContext(ConsolidatedContext)
  const prevGroupId = useRef(groupId)
  const hasFetchedOpeningEvents = useRef(false)
  const dashboardDateRangeRef = useRef(null)
  const [isFromDashboard, setIsFromDashboard] = useState(false)
  const { eventAndOrderById, errorGetEventAndOrder, productList, listEventAndDelivery, listEventAndDeliveryStart, listEventAndDeliveryEnd, packListEvents } =
    useSelector((state) => state.event)

  const [filter, setFilter] = useState({
    listEvent: [],
    rangeDate: [
      {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
    ],
    eventStatus: [],
    paymentStatus: [],
    dateFilterType: 'creation',
  })

  const { listEvent, eventStatus, paymentStatus, rangeDate, dateFilterType } = filter
  const { startDate, endDate } = rangeDate[0]
  const eventId = listEvent.map((event) => event.id)
  const paymentStatusValue = paymentStatus.map((status) => status.value)
  const eventStatusValue = eventStatus.map((status) => status.value)

  const { totalOrderCount } =
    eventAndOrderById.find((item) => item.id === eventId) || {}

  const orderList = listEventAndDelivery?.eventAndOrders
    .map((event) => event.isPercentage ? handleDataOrderByPercentage(event.orders, event.adminCost, event.discount, event.deliveryCost, event.productIdList, event.orderDiscountEnabled, event.orderDiscount).listOrder : handleDataOrder(event.orders, event.adminCost, event.discount, event.deliveryCost, event.productIdList, event.orderDiscountEnabled, event.orderDiscount).listOrder).flat()

  const sortedEvents = useMemo(() => {
    if (!listEventAndDelivery?.eventAndOrders) return []
    return [...listEventAndDelivery.eventAndOrders].sort((a, b) => b.createdAt - a.createdAt)
  }, [listEventAndDelivery])

  const [timeRender, setTimeRender] = useState(0)

  const [sorting, setSorting] = useState({ field: 'eOrderNo', order: 'asc', type: 'number' })

  const [, setTotalOrderCount] = useState(totalOrderCount)
  const [searchString, setSearchString] = useState('')
  const [loading, setLoading] = useState(false)
  const [syncModalOpen, setSyncModalOpen] = useState(false)
  const [consolidateObj, setConsolidateObj] = useState({ isConsolidate: false, index: null })
  const [isHeaderSelectAll, setIsHeaderSelectAll] = useState(false);
  const [orderTab, setOrderTab] = useState('all')
  const [unpaidOrders, setUnpaidOrders] = useState([])
  const [excludeCancelled, setExcludeCancelled] = useState(true)
  const location = useLocation()
  const history = useHistory()

  // const { checkNotification, ShowPopup } = useShowNotification()

  // useEffect(() => {
  //   checkNotification()
  // }, [])

  useEffect(() => {
    const state = location.state || {}
    if (!state?.fromDashboard) return
    setIsFromDashboard(true)
    const { dateRangeOrder, dateRangeEvent, paymentStatus: presetStatus, searchString: presetSearchString } = state

    let newRangeDate = filter.rangeDate
    if (dateRangeOrder?.start && dateRangeOrder?.end) {
      const formatStartDate = new Date(dateRangeOrder.start * 1000)
      formatStartDate.setHours(0, 0, 0, 0)
      const formatEndDate = new Date(dateRangeOrder.end * 1000)
      formatEndDate.setHours(23, 59, 59, 999)
      newRangeDate = [{
        startDate: formatStartDate,
        endDate: formatEndDate,
        key: 'selection',
      }]
    }

    if (dateRangeEvent?.start && dateRangeEvent?.end) {
      dashboardDateRangeRef.current = {
        start: dateRangeEvent.start,
        end: dateRangeEvent.end,
      }
    }
    if (presetSearchString) {
      setSearchString(presetSearchString)
    }
    setFilter(prev => ({
      ...prev,
      rangeDate: newRangeDate,
      paymentStatus: presetStatus ?? [],
    }))
    history.replace({
      pathname: location.pathname,
      search: location.search,
      state: undefined,
    })
  }, [])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const eventIdFromQuery = queryParams.get('eventId')
    if (!eventIdFromQuery || !sortedEvents?.length) return

    const matchedIndex = sortedEvents.findIndex(
      (event) => event.id === Number(eventIdFromQuery) || event.id === eventIdFromQuery
    )

    if (matchedIndex !== -1) {
      const matchedEvent = sortedEvents[matchedIndex]
      const selectEventObject = {
        value: matchedIndex,
        label: matchedEvent.title,
        id: matchedEvent.id,
      }

      setFilter((prev) => ({
        ...prev,
        listEvent: [selectEventObject],
      }))

      const newSearch = new URLSearchParams(location.search)
      newSearch.delete('eventId')
      const searchStr = newSearch.toString()
      history.replace({
        pathname: location.pathname,
        search: searchStr ? `?${searchStr}` : '',
        state: location.state,
      })
    }
  }, [location.search, sortedEvents, history, location.pathname, location.state])

  useEffect(() => {
    const match = location.pathname.match(/^\/manage-orders\/list-(\d+)$/)
    if (match) {
      setConsolidateObj({ isConsolidate: true, index: Number(match[1]) })
    } else if (location.pathname === '/manage-orders') {
      setConsolidateObj({ isConsolidate: false, index: null })

      const hasEventId = new URLSearchParams(location.search).has('eventId')
      if (!hasEventId) {
        setFilter(prev => ({ ...prev, listEvent: [] }))
      }
    }
  }, [location.pathname])

  useEffect(() => {
    if (consolidateObj.isConsolidate) {
      dispatch(getPackingListEvents(listRef[consolidateObj.index - 1]?.eIds))
    }
  }, [consolidateObj])

  useEffect(() => {
    const fetchUnpaidOrders = async () => {
      if (orderTab !== 'unpaid' || !groupId) return

      setLoading(true)
      try {
        const response = await orderApi.getUnpaidOrderByGroupOfHost(groupId)
        if (response?.msgResp?.eventAndOrders) {
          const resUnpaidOrders = response.msgResp.eventAndOrders.flatMap(event => {
            const { orders, adminCost, discount, deliveryCost, productIdList, isPercentage = false, orderDiscountEnabled, orderDiscount } = event;
            const handler = isPercentage ? handleDataOrderByPercentage : handleDataOrder;
            return handler(orders, adminCost, discount, deliveryCost, productIdList ? [...productIdList] : [], orderDiscountEnabled, orderDiscount).listOrder || []
          })
          setUnpaidOrders(
            resUnpaidOrders.filter(order => (order.status === HOST_ORDER_UNPAID || order.status === HOST_ORDER_SUBMITTED_UNPAID))
          )
        }
      } catch (error) {
        console.error('Failed to fetch unpaid orders:', error)
        addToast('Failed to load unpaid orders', { appearance: 'error', autoDismiss: true })
        setUnpaidOrders([])
      } finally {
        setLoading(false)
      }
    }

    fetchUnpaidOrders()
  }, [orderTab, groupId, timeRender])

  const displayOrderList = useMemo(() => {
    const currentList = (orderTab === 'unpaid' ? unpaidOrders : orderList) || []

    if (excludeCancelled) {
      return currentList.filter(order =>
        order.status !== HOST_ORDER_CANCELED && order.buyerStatus !== BUYER_ORDER_CANCELED
      )
    }
    return currentList
  }, [orderTab, unpaidOrders, orderList, excludeCancelled])

  const onChangeSearch = (event) => {
    setSearchString(event.target.value)
  }

  const handleSyncData = () => {
    setSyncModalOpen(true)
  }

  const [eventPage, setEventPage] = useState(1)
  const [eventPageFilter, setEventPageFilter] = useState(1)
  const PAGINATION_ORDERS = 20

  const handleClearFilter = () => {
    setFilter({
      ...filter,
      listEvent: consolidateObj.isConsolidate ? filter.listEvent : [],
      eventStatus: [],
      rangeDate: [
        {
          startDate: null,
          endDate: null,
          key: 'selection',
        },
      ],
      paymentStatus: [],
    })
    setSearchString('')
    setIsFromDashboard(false)
    setEventPage(1)
    setEventPageFilter(1)
  }

  const handleChangeEvent = (options) => {
    const optionSelected = (options?.selectedOption || []).map((option) => option)
    setFilter({
      ...filter,
      listEvent: [...optionSelected],
    })
  }

  const handleChangeDate = (data, filterType = 'creation') => {
    const formatStartDate = new Date(data[0].startDate.setHours(0, 0, 0, 0))
    const formatEndDate = new Date(data[0].endDate.setHours(23, 59, 59, 999))

    setFilter({
      ...filter,
      rangeDate: [
        {
          startDate: formatStartDate,
          endDate: formatEndDate,
          key: 'selection',
        },
      ],
      dateFilterType: filterType,
    })
  }

  const onChangeRangeDate = async (data) => {
    const formatStartDate = new Date(data[0].startDate.setHours(0, 0, 0, 0))
    const formatEndDate = new Date(data[0].endDate.setHours(23, 59, 59, 999))

    const start = Math.floor(formatStartDate.getTime() / 1000)
    const end = Math.floor(formatEndDate.getTime() / 1000)

    setLoading(true)
    try {
      await dispatch(getListEventAndDelivery(groupId, { start, end }))
    } finally {
      setLoading(false)
      setSyncModalOpen(false)
    }
  }

  const handleChangeEventStatus = (options) => {
    const optionSelected = options.selectedOption.map((option) => option)
    setFilter({
      ...filter,
      eventStatus: [...optionSelected],
    })
  }

  const handlePaymentStatus = (options) => {
    const optionSelected = options.selectedOption.map((option) => option)
    setFilter({
      ...filter,
      paymentStatus: [...optionSelected],
    })
  }

  const consolidatedEventIds = useMemo(() => {
    if (!consolidateObj.isConsolidate || !listRef?.length) return []
    const idx = Math.max(0, (consolidateObj.index || 1) - 1)
    const c = listRef[idx]
    return c?.eIds || []
  }, [consolidateObj, listRef])

  const [consolidatedOrders, setConsolidatedOrders] = useState([])
  const [consolidatedEvents, setConsolidatedEvents] = useState([])
  const [loadingConsolidated, setLoadingConsolidated] = useState(false)

  useEffect(() => {
    const fetchConsolidatedOrders = async () => {
      if (!consolidatedEventIds?.length) {
        setConsolidatedOrders([])
        setFilter(prev => ({ ...prev, listEvent: [] }))
        return
      }

      setLoadingConsolidated(true)
      try {
        const sortedEventIds = new Set(sortedEvents.map(e => e.id))
        const missingEventIds = consolidatedEventIds.filter(id => !sortedEventIds.has(id))

        let allOrders = Array.isArray(orderList) ? [...orderList] : []
        let newlyFetchedEvents = []

        if (missingEventIds.length > 0) {
          const response = await orderApi.getListOrderByEventsOpening(groupId, missingEventIds)
          if (response?.msgResp?.eventAndOrders) {
            newlyFetchedEvents = response.msgResp.eventAndOrders

            setConsolidatedEvents(newlyFetchedEvents)
            const missingOrders = newlyFetchedEvents.flatMap(event => {
              const handler = event.isPercentage ? handleDataOrderByPercentage : handleDataOrder;
              return handler(event.orders, event.adminCost, event.discount, event.deliveryCost, event.productIdList, event.orderDiscountEnabled, event.orderDiscount).listOrder || []
            })
            allOrders = [...allOrders, ...missingOrders]
          }
        }

        const filteredOrders = allOrders.filter(o => consolidatedEventIds.includes(o.eid))
        setConsolidatedOrders(filteredOrders)

        const allAvailableEvents = [...(sortedEvents || []), ...newlyFetchedEvents]
        const eventsForFilter = allAvailableEvents.filter(event =>
          consolidatedEventIds.includes(event.id)
        )

        const uniqueEvents = [...new Map(eventsForFilter.map(item => [item.id, item])).values()]
        const selectEventObjects = uniqueEvents.map(ev => ({
          ...ev,
          label: ev.title,
          value: ev.id,
        }))

        setFilter(prev => ({
          ...prev,
          listEvent: selectEventObjects
        }))
      } catch (error) {
        console.error('Failed to fetch consolidated orders:', error)
        addToast('Failed to load consolidated orders', { appearance: 'error', autoDismiss: true })
        setConsolidatedOrders([])
        setFilter(prev => ({ ...prev, listEvent: [] }))
      } finally {
        setLoadingConsolidated(false)
      }
    }

    if (consolidateObj.isConsolidate) {
      fetchConsolidatedOrders()
    }
  }, [consolidatedEventIds, groupId, consolidateObj.isConsolidate, sortedEvents])

  const hasActiveFilters = useMemo(() => {
    return (
      eventId.length > 0 ||
      eventStatus.length > 0 ||
      paymentStatus.length > 0 ||
      (startDate !== null && endDate !== null) ||
      searchString.trim() !== ''
    )
  }, [eventId.length, eventStatus, paymentStatus.length, startDate, endDate, searchString])

  const initialOrder = async (force = false) => {
    setLoading(true)
    try {
      let start
      let end
      if (dashboardDateRangeRef.current) {
        start = dashboardDateRangeRef.current.start || null
        end = dashboardDateRangeRef.current.end || null
        dashboardDateRangeRef.current = null
      } else {
        end = moment().unix()
        start = moment().subtract(1, 'months').startOf('day').unix()
      }
      if (force || !listEventAndDelivery?.eventAndOrders?.length || start !== undefined) {
        await dispatch(getListEventAndDelivery(groupId, { start, end }))
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const fetchOpeningEventsOrders = async () => {
      if (hasFetchedOpeningEvents.current) {
        return
      }

      if (!listEventAndDelivery?.eventAndOrders?.length || !groupId) {
        return
      }

      const currentTime = Date.now() / 1000

      const openingEvents = listEventAndDelivery.eventAndOrders.filter(
        event => event.closingTimestamp > currentTime
      )

      if (openingEvents.length === 0) {
        hasFetchedOpeningEvents.current = true
        return
      }

      const openingEventIds = openingEvents.map(event => event.id)

      let lastOrderTimestamp = 0
      openingEvents.forEach(event => {
        if (event.orders && Array.isArray(event.orders)) {
          event.orders.forEach(order => {
            if (order.createdAt && order.createdAt > lastOrderTimestamp) {
              lastOrderTimestamp = order.createdAt
            }
          })
        }
      })

      try {
        const response = await orderApi.getListOrderByEventsOpening(groupId, openingEventIds, lastOrderTimestamp)

        if (response?.msgResp?.eventAndOrders) {
          const updatedEvents = response.msgResp.eventAndOrders

          dispatch(updateOpeningEventsOrders(updatedEvents))
          hasFetchedOpeningEvents.current = true
        }
      } catch (error) {
        console.error('Error calling API:', error)
      }
    }

    fetchOpeningEventsOrders()
  }, [groupId, addToast, dispatch])

  useEffect(() => {
    hasFetchedOpeningEvents.current = false
  }, [groupId])

  useEffect(() => {
    if (groupId === undefined) return
    const isGroupChanged = prevGroupId.current !== groupId
    const force = isGroupChanged
    initialOrder(force)
    if (force) {
      handleClearFilter()
    }
    prevGroupId.current = groupId
  }, [groupId, timeRender])

  useEffect(() => {
    const container = document.getElementById('manage-order-page')
    if (!container) return

    const onClickCapture = (e) => {
      const anchor = e.target.closest('a[href="#"], a[href=""]')
      if (anchor) {
        e.preventDefault()
        e.stopPropagation()
      }
    }

    container.addEventListener('click', onClickCapture, true)
    return () => container.removeEventListener('click', onClickCapture, true)
  }, [])

  useEffect(() => {
    setTotalOrderCount(totalOrderCount)
  }, [totalOrderCount])

  const listOrderFiltered = useMemo(() => {
    let filteredOrders = []
    if (displayOrderList && displayOrderList.length > 0) {
      filteredOrders = [...displayOrderList]
    } else {
      return []
    }

    if (eventId.length > 0) {
      filteredOrders = filteredOrders.filter((order) => eventId.includes(order.eid))
    }

    if (paymentStatus.length > 0) {
      filteredOrders = filteredOrders.filter((order) => checkMatchesPaymentStatus(order, paymentStatus))
    }

    if (startDate !== null && endDate !== null) {
      if (dateFilterType === 'creation') {
        filteredOrders = filteredOrders.filter((order) =>
          moment(order.createdAt * 1000).isBetween(startDate, endDate, null, '[]')
        )
      } else if (dateFilterType === 'closure') {
        filteredOrders = filteredOrders.filter((order) => {
          const event = sortedEvents.find((e) => e.id === order.eid)
          if (!event || !event.closingTimestamp) return false
          const closingDate = moment.unix(event.closingTimestamp)
          return closingDate.isBetween(startDate, endDate, null, '[]')
        })
      }
    }

    if (eventStatus.length > 0) {
      let eventsFilteredByStatus = []
      eventsFilteredByStatus = sortedEvents.filter((e) => {
        const isOpen = e.closingTimestamp > now
        const isClosed = e.closingTimestamp <= now

        return eventStatusValue.some(status => {
          if (status === EVENT_STATUS_OPEN) return isOpen
          if (status === EVENT_STATUS_CLOSE) return isClosed
          return false
        })
      })

      filteredOrders = filteredOrders.filter((order) =>
        eventsFilteredByStatus.some((event) => event.id === order.eid)
      )
    }

    return filteredOrders
  }, [eventId, eventStatus, paymentStatus, startDate, endDate, displayOrderList, paymentStatusValue, dateFilterType, sortedEvents])

  const listOrders = useMemo(() => {
    if (listOrderFiltered !== undefined) {
      let listOrderSort = [...listOrderFiltered]
      if (searchString) {
        listOrderSort = listOrderSort.filter(
          (item) =>
            item.uPhone.toString().includes(searchString) ||
            item.uName.toLowerCase().includes(searchString.toLowerCase()) ||
            item.ref.toLowerCase().includes(searchString.toLowerCase())
        )
      }
      if (sorting.field) {
        const reversed = sorting.order === 'asc' ? 1 : -1
        if (sorting.type === 'string') {
          listOrderSort = listOrderSort.sort(
            (a, b) => reversed * a[sorting.field]?.localeCompare(b[sorting.field])
          )
        } else {
          listOrderSort = listOrderSort.sort(
            (a, b) => reversed * (a[sorting.field] - b[sorting.field])
          )
        }
      }
      return listOrderSort
    }
    return []
  }, [sorting, searchString, listOrderFiltered])

  const handleConsolidate = async () => {
    try {
      const refs = (listOrders || []).map((item) => item.ref)
      if (!refs.length) {
        addToast('No orders to consolidate', { appearance: 'warning', autoDismiss: true })
        return
      }

      const eIdsSet = new Set((listOrders || []).map((item) => item.eid))
      const eIds = Array.from(eIdsSet)

      await userApi.createListConsolidated(groupId, eIds, `List ${count + 1}`)
      addConsolidated(refs)
      const newIndex = (count || 0) + 1
      setConsolidateObj({ isConsolidate: true, index: newIndex })

      addToast('Consolidated list created', { appearance: 'success', autoDismiss: true })
      await refreshConsolidated()
      history.push(`/manage-orders/list-${newIndex}`)
    } catch (error) {
      const msg = error?.msgResp || 'Failed to consolidate'
      addToast(msg, { appearance: 'error', autoDismiss: true })
    }
  }

  const totalPages = Math.ceil(listOrders.length / PAGINATION_ORDERS)
  const totalPagesFilter = useMemo(() => {
    const total =
      !hasActiveFilters
        ? listOrders.length
        : (searchString.trim() !== ''
            ? listOrders.length
            : (listOrderFiltered?.length || 0))
    return Math.ceil(total / PAGINATION_ORDERS)
  }, [hasActiveFilters, listOrders.length, listOrderFiltered?.length, searchString])

  useEffect(() => {
    setEventPageFilter(prev => {
      const maxPage = Math.max(totalPagesFilter || 0, 1)
      if (prev < 1) return 1
      if (prev > maxPage) return maxPage
      return prev
    })
  }, [totalPagesFilter])

  useEffect(() => {
    setEventPage(prev => {
      const maxPage = Math.max(totalPages || 0, 1)
      if (prev < 1) return 1
      if (prev > maxPage) return maxPage
      return prev
    })
  }, [totalPages])

  const currentOrders = useMemo(() => {
    const countOrders = PAGINATION_ORDERS * eventPage
    const startIndex = (eventPage - 1) * PAGINATION_ORDERS
    return listOrders?.slice(startIndex, countOrders)
  }, [listOrders, eventPage])

  const currentOrdersFilter = useMemo(() => {
    const countOrders = PAGINATION_ORDERS * eventPageFilter
    const startIndex = (eventPageFilter - 1) * PAGINATION_ORDERS
    return listOrders?.slice(startIndex, countOrders)
  }, [listOrders, eventPageFilter])

  const filteredConsolidatedOrders = useMemo(() => {
    if (!consolidatedOrders) return []
    let result = [...consolidatedOrders]
    const allEvents = [...(sortedEvents || []), ...(consolidatedEvents || [])]

    if (searchString.trim()) {
      const searchLower = searchString.toLowerCase().trim()
      result = result.filter((item) =>
        (item.uPhone && item.uPhone.toString().includes(searchLower)) ||
        (item.uName && item.uName.toLowerCase().includes(searchLower))
      )
    }

    if (eventStatus.length > 0) {
      const eventsFilteredByStatus = allEvents.filter((e) => {
        const isOpen = e.closingTimestamp > now
        const isClosed = e.closingTimestamp <= now

        return eventStatusValue.some(status => {
          if (status === EVENT_STATUS_OPEN) return isOpen
          if (status === EVENT_STATUS_CLOSE) return isClosed
          return false
        })
      })

      result = result.filter((order) =>
        eventsFilteredByStatus.some((event) => event.id === order.eid)
      )
    }

    if (paymentStatus.length > 0) {
      result = result.filter((order) => checkMatchesPaymentStatus(order, paymentStatus))
    }

    if (startDate !== null && endDate !== null) {
      if (dateFilterType === 'creation') {
        result = result.filter((order) =>
          moment(order.createdAt * 1000).isBetween(startDate, endDate, null, '[]')
        )
      } else if (dateFilterType === 'closure') {
        result = result.filter((order) => {
          const event = allEvents.find((e) => e.id === order.eid)
          if (!event || !event.closingTimestamp) return false
          const closingDate = moment.unix(event.closingTimestamp)
          return closingDate.isBetween(startDate, endDate, null, '[]')
        })
      }
    }

    return result
  }, [
    consolidatedOrders,
    searchString,
    eventStatus,
    eventStatusValue,
    paymentStatus,
    paymentStatusValue,
    startDate,
    endDate,
    dateFilterType,
    sortedEvents,
    consolidatedEvents
  ])

  const filterBeforeExport = (format) => {
    function handleFilterListOrder() {
      let listIdEventFromOrders
      let listRefOfOder
      if (consolidateObj.isConsolidate) {
        listIdEventFromOrders = filteredConsolidatedOrders?.map((item) => item.eid)
        listRefOfOder = filteredConsolidatedOrders?.map((item) => item.ref)
      } else {
        listIdEventFromOrders = listOrderFiltered?.map((item) => item.eid)
        listRefOfOder = listOrderFiltered?.map((item) => item.ref)
      }
      const uniqueEventIds = Array.from(new Set(listIdEventFromOrders))
      const listEventUnique = []
      for (let i = 0; i < uniqueEventIds?.length; i++) {
        const event = listEventAndDelivery?.eventAndOrders?.find(
          (item) => item.id === uniqueEventIds[i]
        );

        if (event) listEventUnique.push(event);
      }
      if (consolidateObj.isConsolidate && Array.isArray(consolidatedEvents) && consolidatedEvents.length > 0) {
        const existingIds = new Set(listEventUnique.map(ev => ev.id))
        const uniqueConsolidated = consolidatedEvents.filter(ev => !existingIds.has(ev.id))
        listEventUnique.push(...uniqueConsolidated)
      }
      const listTotalOrderAfterFilter = []
      for (let i = 0; i < listEventUnique?.length; i++) {
        const arrOderAfter = []
        for (let k = 0; k < listRefOfOder.length; k++) {
          const matchingOrders = listEventUnique[i]?.orders.filter((item) => item.ref === listRefOfOder[k]);
          arrOderAfter.push(...matchingOrders);
        }
        listTotalOrderAfterFilter.push({
          ...listEventUnique[i],
          orders: arrOderAfter.filter((el) => el !== undefined),
        })
      }
      handleExportMultipleEventAndOrder(listTotalOrderAfterFilter, format)
    }
    const hasOrders = consolidateObj.isConsolidate
      ? filteredConsolidatedOrders?.length
      : listOrderFiltered?.length
    if (hasOrders) {
      handleFilterListOrder()
    } else {
      addToast('No orders to export', { appearance: 'warning', autoDismiss: true })
    }
  }

  const listOrderExportPdf = useMemo(() => {
    if (!consolidateObj.isConsolidate || !filteredConsolidatedOrders?.length) return []

    const groupedMap = {}

    filteredConsolidatedOrders.forEach((order) => {
      if (!groupedMap[order.uid]) {
        groupedMap[order.uid] = {
          uid: order.uid,
          uName: order.uName,
          uEmail: order.uEmail,
          uPhone: order.uPhone,
          refs: [],
          events: [],
          statusPaid: 0,
          allProductPerOrder: [],
          adminCostPerOrder: 0,
          totalFeeAllOrder: 0,
          totalDeliveryPerOrder: 0,
          totalDiscountPerOrder: 0,
          totalPricePerOrder: 0,
          orders: [],
        }
      }

      const currentUser = groupedMap[order.uid]

      currentUser.refs.push(order.ref)
      currentUser.statusPaid += order.status >= 2 ? 1 : 0
      currentUser.totalFeeAllOrder += order.totalFee || 0
      currentUser.totalDeliveryPerOrder += order.deliveryPerOrder || 0
      currentUser.totalDiscountPerOrder += order.discountPerOrder || 0
      currentUser.totalPricePerOrder += order.totalPricePerOrder || 0
      currentUser.adminCostPerOrder += order.adminCostPerOrder || 0

      if (order.allProductPerOrder) {
        currentUser.allProductPerOrder.push(...order.allProductPerOrder)
      }

      const eventInfo = packListEvents.find(e => e.id === order.eid)
      if (eventInfo) {
        const isEventExist = currentUser.events.some(
          ev => ev.title === eventInfo.title && ev.pickupTime === eventInfo.pickupTime
        )

        if (!isEventExist) {
          currentUser.events.push({
            title: eventInfo.title,
            groupName: eventInfo.groupName,
            pickupTime: eventInfo.pickupTime,
            closingTime: eventInfo.closingTime,
          })
        }
      }

      currentUser.orders.push({
        ref: order.ref,
        bookingAddress: order.bookingAddress,
        status: order.status,
        totalFee: order.totalFee,
        deliveryPerOrder: order.deliveryPerOrder,
        discountPerOrder: order.discountPerOrder,
        totalPricePerOrder: order.totalPricePerOrder,
        buyerStatus: order.buyerStatus,
        ePickupAddress: eventInfo?.pickupAddress,
        combinedPaymentRef: order.combinedPaymentRef,
        deliveryDate: order.deliveryDate,
        consignee: order.consignee,
      })
    })

    return Object.values(groupedMap)
  }, [consolidateObj.isConsolidate, filteredConsolidatedOrders, packListEvents])

  return (
    <Container
      fluid
      id='manage-order-page'
      style={{
        padding: '0 2rem',
      }}
    >
      <Row className='my-3 px-3 align-items-center'>
        <Col>
          <span className='ps-3 fw-bold text-orange fs-2'>Manage Order</span>
        </Col>
        <Col className='d-flex align-items-center text-uppercase justify-content-end'>
          {consolidateObj.isConsolidate && (
            <Button
              role='button'
              className='btn-export rounded-0 ms-3 shadow-none'
              onClick={() => handleDownloadPdf(
                listOrderExportPdf,
                listRef[consolidateObj.index - 1]?.name,
                productList
              )}
              outline
            >
              Export Pdf
            </Button>
          )}
          <Button
            role='button'
            className='btn-export rounded-0 ms-3 shadow-none'
            onClick={() => filterBeforeExport(format1)}
            outline
          >
            Export List
          </Button>
          <Button
            role='button'
            className='btn-export rounded-0 ms-3 shadow-none'
            onClick={() => filterBeforeExport(format2)}
            outline
          >
            Export Matrix
          </Button>
          {!consolidateObj.isConsolidate && (<Button
            role='button'
            className='btn-export rounded-0 ms-3 shadow-none'
            onClick={handleSyncData}
            outline
          >
            <FaCalendarAlt style={{ marginRight: 6, verticalAlign: 'middle', fontSize: '1.3em' }} />
            Date
          </Button>)}
          {!consolidateObj.isConsolidate && (
            <Button
              role='button'
              className='btn-export rounded-0 ms-3 shadow-none'
              onClick={handleConsolidate}
              outline
            >
              Consolidate
            </Button>
          )}
        </Col>
      </Row>

      <Row className='align-items-center px-3 mb-3 justify-content-between'>
        <Col style={{ maxWidth: '400px' }}>
          <OrderSearch
            searchString={searchString}
            onChange={onChangeSearch}
            styles={{ marginTop: 0 }}
            isConsolidate={consolidateObj.isConsolidate}
          />
        </Col>
        <Col className='text-end fw-bold'>
          {!consolidateObj.isConsolidate && orderTab !== 'unpaid' && !isFromDashboard && (() => {
            const startUnix = listEventAndDeliveryStart ?? moment().subtract(1, 'months').startOf('day').unix()
            const endUnix = listEventAndDeliveryEnd ?? moment().unix()
            const startToShow = moment.unix(startUnix).format('DD/MM/YYYY')
            const endToShow = moment.unix(endUnix).format('DD/MM/YYYY')
            return (
              <span>
                Loading events created from <strong className='text-orange'>{startToShow}</strong> to{' '}
                <strong className='text-orange'>{endToShow}</strong>
              </span>
            )
          })()}
        </Col>
      </Row>
      <Row className='px-3'>
        <Col>
          <SelectFilter
            filter={filter}
            listEventGroupIdByHost={sortedEvents}
            onChangeEvent={handleChangeEvent}
            onChangeEventStatus={handleChangeEventStatus}
            onChangePaymentStatus={handlePaymentStatus}
            onChangeRangeDate={handleChangeDate}
            handleClearFilter={handleClearFilter}
            orderTab={orderTab}
            isConsolidate={consolidateObj.isConsolidate}
          />
        </Col>
      </Row>
      {currentOrders && !errorGetEventAndOrder ? (
        <>
          <div className='row-top'>
            <div className='d-flex list-event-note align-items-center justify-content-between px-3' style={{ marginBottom: '4px' }}>
              <div>
                Click on Names for Order Details and on <i className='icon-link'></i> for Payment
                Details.
              </div>
              {!consolidateObj.isConsolidate && (
                rangeDate[0].startDate && rangeDate[0].endDate ? (
                  <div className='text-center'>
                    {dateFilterType === 'closure' ? (
                      <>
                        Orders have closing date from{' '}
                        <strong className='text-orange'>
                          {moment(rangeDate[0].startDate).format('DD/MM/YYYY')}
                        </strong>{' '}
                        to{' '}
                        <strong className='text-orange'>
                          {moment(rangeDate[0].endDate).format('DD/MM/YYYY')}
                        </strong>
                        {!(isFromDashboard && loading) && ` (${listOrders.length} orders)`}
                      </>
                    ) : (
                      <>
                        Listing orders from{' '}
                        <strong className='text-orange'>
                          {moment(rangeDate[0].startDate).format('DD/MM/YYYY')}
                        </strong>{' '}
                        to{' '}
                        <strong className='text-orange'>
                          {moment(rangeDate[0].endDate).format('DD/MM/YYYY')}
                        </strong>
                        {!(isFromDashboard && loading) && ` (${listOrders.length} orders)`}
                      </>
                    )}
                  </div>
                ) : (
                  <div className='d-flex flex-column align-items-end'>
                    <span className='text-orange'>
                      Total order:{' '}
                      {!hasActiveFilters
                        ? listOrders.length
                        : (searchString.trim() !== '' ? listOrders.length : (listOrderFiltered?.length || 0))}
                    </span>
                    {orderTab === 'unpaid' && (
                      <span className='text-orange'>
                        Total unpaid: ${formatNumberEng(displayOrderList.reduce((sum, order) => sum + (order.totalPricePerOrder || 0), 0), 2)}
                      </span>
                    )}
                  </div>
                )
              )}
            </div>
            {isHeaderSelectAll && (
              <div className='d-flex align-items-center justify-content-between px-3 mt-0'>
                <span className='fw-bold text-orange text-underline'>
                  You can select up to 5 orders only
                </span>
              </div>
            )}
            {loading || loadingConsolidated ? (
              <div className='px-3'>
                <OrderListSkeleton />
              </div>
            ) : (consolidateObj.isConsolidate ? filteredConsolidatedOrders?.length > 0 : currentOrders && currentOrders.length > 0) ? (
              <div className='px-3'>
                <OrderList
                  listOrder={
                    consolidateObj.isConsolidate
                      ? filteredConsolidatedOrders
                      : (hasActiveFilters ? currentOrdersFilter : (currentOrders || []))
                  }
                  setTimeRender={setTimeRender}
                  setSorting={setSorting}
                  pagedEvents={sortedEvents || []}
                  isConsolidate={consolidateObj.isConsolidate}
                  isHeaderSelectAll={isHeaderSelectAll}
                  setIsHeaderSelectAll={setIsHeaderSelectAll}
                  orderTab={orderTab}
                  setOrderTab={setOrderTab}
                  consolidatedEventIds={consolidateObj.isConsolidate ? consolidatedEventIds : []}
                  excludeCancelled={excludeCancelled}
                  setExcludeCancelled={setExcludeCancelled}
                />
              </div>
            ) : null}

            {(() => {
              if (loading || loadingConsolidated) return null

              if (consolidateObj.isConsolidate) {
                if (filteredConsolidatedOrders?.length === 0) {
                  if (hasActiveFilters || (consolidatedOrders && consolidatedOrders.length > 0)) {
                    return <NotFoundOrder message={searchString.trim() !== '' ? "No orders match your search" : undefined} />
                  }
                }
                return null
              }
              const currentList = hasActiveFilters ? listOrderFiltered : listOrders

              if (currentList?.length === 0) {
                 if (hasActiveFilters || searchString.trim() !== '') {
                    return <NotFoundOrder message={searchString.trim() !== '' ? "No orders match your search" : undefined} />
                 }
                 if (hasActiveFilters && listOrderFiltered?.length === 0) {
                    return <NotFoundOrder />
                 }
              }

              return null
            })()}
          </div>
        </>
      ) : null}

      {currentOrders === undefined && (
        <div className='px-3 mt-3'>
          <OrderListSkeleton />
        </div>
      )}
      {!consolidateObj.isConsolidate && (
        !hasActiveFilters ? (
          <PaginationNumbers
            currentPage={eventPage}
            totalPages={totalPages}
            onPageChange={(newPage) => {
              setEventPage(newPage)

              setTimeout(() => {
                document.getElementById('manage-order-page').scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                })
              }, 0)
            }}
          />
        ) : (
          <PaginationNumbers
            currentPage={eventPageFilter}
            totalPages={totalPagesFilter}
            onPageChange={(newPage) => {
              setEventPageFilter(newPage)

              setTimeout(() => {
                document.getElementById('manage-order-page').scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                })
              }, 0)
            }}
          />
        )
      )}
      <SelectDateSyncData
        isOpen={syncModalOpen}
        onClose={() => setSyncModalOpen(false)}
        onChangeRangeDate={onChangeRangeDate}
      />
      {/* {ShowPopup} */}
    </Container>
  )
}

export default WithErrorBoundary(ManageOrder)
